module.exports = __webpack_public_path__ + "static/media/2 (21).4adaef5a.jpg";